import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import editPencilIcon from '../../../assets/img/icons/edit-pencil.svg';
import buildingIcon from '../../../assets/img/icons/building.svg';
import listTodoIcon from '../../../assets/img/icons/list-todo.svg';
import TableCustomCheckboxDropdownPill from '../../../components/CustomCheckboxDropdown/TableCustomCheckboxDropdownPill';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../../components/NoDataComponent/NoDataComponent';
import TaskActionTooltip from '../../../components/Tooltip/TaskActionTooltip';
import { TableItem } from '../../../styledComponents/ProjectsNew';
import {
  CommonImage,
  Container,
  TableText,
} from '../../../styledComponents/common';
import {
  MasterTaskTable,
} from '../../../styledComponents/tasks';
import { EditButtonIcon } from '../tasksStyles';
import Status from 'components/Status/Status';

const EmtithalMasterTasksList = ({
  emtithalMasterTasksList,
  editEmtithalMasterTask,
  isLoading = false,
  publicZoneList,
}) => {
  const { t } = useTranslation();
  const [openedOfficeDropdown, setOpenedOfficeDropdown] = useState(null);
  const [openedMasterSubTaskDropdown, setOpenedMasterSubTaskDropdown] =
    useState(null);

  const handleOfficeDropdownClick = id => {
    if (openedOfficeDropdown === id) {
      setOpenedOfficeDropdown(null);
    } else {
      setOpenedOfficeDropdown(id);
    }
  };

  const handleMasterSubTaskDropdownClick = id => {
    if (openedMasterSubTaskDropdown === id) {
      setOpenedMasterSubTaskDropdown(null);
    } else {
      setOpenedMasterSubTaskDropdown(id);
    }
  };

  const handleEdit = task => {
    editEmtithalMasterTask({ task_id: task.id, ...task });
  };

  return (
    <Container style={{ paddingBottom: '20px' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : emtithalMasterTasksList && emtithalMasterTasksList.length > 0 ? (
        <>
          <MasterTaskTable columns="150px 150px 100px 150px 250px 50px" heading>
            <TableItem>
              <TableText>{t('task_code')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('name')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('public_zone')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('related_offices')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('related_etqan_master_subtasks')}</TableText>
            </TableItem>
            <TableItem>
              <TableText />
            </TableItem>
          </MasterTaskTable>
          {emtithalMasterTasksList?.map(task => (
            <MasterTaskTable columns="150px 150px 100px 150px 250px 50px" key={task.id}>
              <TableItem>
                <TableText>{task.code}</TableText>
              </TableItem>
              <TableItem>
                <TableText>{task.name}</TableText>
              </TableItem>
              <TableItem>
                <Status status={publicZoneList?.find(
                  zone => zone.id === task.public_zone || zone.id === task.public_zone_id,
                )?.name} showDot={true} />
              </TableItem>
              <TableItem>
                {task.related_offices && task.related_offices.length > 0 ? (
                  <TableCustomCheckboxDropdownPill
                    opened={openedOfficeDropdown === task.id}
                    options={(task.related_offices || task.office || []).map(office => ({
                      label: office.name,
                      value: office.id,
                    }))}
                    selectedOptions={(task.related_offices || task.office || []).map(office => ({
                      label: office.name,
                      value: office.id,
                    }))}
                    onClick={() => handleOfficeDropdownClick(task.id)}
                    onChange={() => {}}
                    placeholder="related_offices"
                    countLabel="offices"
                    icon={<img src={buildingIcon} alt="" />}
                  />
                ) : (
                  <TableText>-</TableText>
                )}
              </TableItem>
              <TableItem>
                {(task.sub_tasks || task.master_tasks) &&
                (task.sub_tasks || task.master_tasks).length > 0 ? (
                  <TableCustomCheckboxDropdownPill
                    opened={openedMasterSubTaskDropdown === task.id}
                    options={(task.sub_tasks || task.master_tasks || []).map(mt => ({
                      label: mt.name,
                      value: mt.id,
                    }))}
                    selectedOptions={(task.sub_tasks || task.master_tasks || []).map(mt => ({
                      label: mt.name,
                      value: mt.id,
                    }))}
                    onClick={() => handleMasterSubTaskDropdownClick(task.id)}
                    onChange={() => {}}
                    placeholder="related_etqan_master_subtasks"
                    countLabel="master_subtasks"
                    icon={<img src={listTodoIcon} alt="" />}
                  />
                ) : (
                  <TableText>-</TableText>
                )}
              </TableItem>
              <TableItem>
                <EditButtonIcon onClick={() => handleEdit(task)} title={t('edit_task')}>
                  <CommonImage src={editPencilIcon} alt="" />
                </EditButtonIcon>
              </TableItem>
            </MasterTaskTable>
          ))}
        </>
      ) : (
        <NoDataComponent
          title={t('no_emtithal_master_tasks_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default EmtithalMasterTasksList;
